"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCOUNT_SALES_TYPE = exports.PROMOTION_TYPE = void 0;
/**
 * We could eventually split DISCOUNT into PERCENTAGE_DISCOUNT and AMOUNT_DISCOUNT
 */
var PROMOTION_TYPE;
(function (PROMOTION_TYPE) {
    PROMOTION_TYPE["DISCOUNT"] = "DISCOUNT";
    PROMOTION_TYPE["BUY_X_GET_Y"] = "BUY_X_GET_Y";
})(PROMOTION_TYPE || (exports.PROMOTION_TYPE = PROMOTION_TYPE = {}));
var DISCOUNT_SALES_TYPE;
(function (DISCOUNT_SALES_TYPE) {
    DISCOUNT_SALES_TYPE["AMOUNT"] = "AMOUNT";
    DISCOUNT_SALES_TYPE["QUANTITY"] = "QUANTITY";
})(DISCOUNT_SALES_TYPE || (exports.DISCOUNT_SALES_TYPE = DISCOUNT_SALES_TYPE = {}));
